import { sysdyneTheme as theme, sysdyneThemeConfig as defaults } from '@/theme';
import { createVuetify } from 'vuetify';

export default createVuetify({
  theme,
  defaults,
});
